var _rect, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVideoIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 56,
    height: 56,
    rx: 28,
    fill: "#4A56DB"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.7324 25.405C19.2302 24.8633 19.8817 24.5215 20.5804 24.4354C22.757 24.1807 24.896 24.1805 27.0726 24.4354C27.7714 24.5215 28.4228 24.8633 28.9207 25.405C29.4185 25.9468 29.7335 26.6566 29.8141 27.4187C29.8514 27.7809 29.883 28.1411 29.9089 28.4998C30.439 28.1921 31.0098 27.9082 31.604 27.6774C32.2571 27.4237 32.9723 27.7343 33.1819 28.4028C33.3904 29.0673 33.5719 29.9575 33.5719 30.9807C33.5719 32.0039 33.3904 32.8941 33.1819 33.5585C32.9723 34.227 32.2571 34.5377 31.604 34.284C31.0097 34.0531 30.4388 33.7691 29.9086 33.4614C29.8829 33.8202 29.8517 34.1805 29.8151 34.5426C29.7345 35.3048 29.4195 36.0146 28.9217 36.5564C28.4238 37.0982 27.7724 37.44 27.0736 37.526C24.8966 37.7805 22.7574 37.7807 20.5804 37.526C19.8817 37.44 19.2302 37.0982 18.7324 36.5564C18.2345 36.0146 17.9196 35.3048 17.8389 34.5426C17.5916 32.1392 17.5918 29.8222 17.8389 27.4187C17.9196 26.6566 18.2345 25.9468 18.7324 25.405Z",
    stroke: "white",
    strokeWidth: 1.7136,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31.4636 17.6527C33.2895 17.6527 35.0406 18.378 36.3316 19.6691C37.6228 20.9602 38.3481 22.7113 38.3481 24.5372",
    stroke: "white",
    strokeWidth: 1.7136,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M31.4636 22.1494C32.0969 22.1494 32.7042 22.4009 33.152 22.8487C33.5998 23.2965 33.8515 23.9039 33.8515 24.5372",
    stroke: "white",
    strokeWidth: 1.7136,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideoIcon);
export default __webpack_public_path__ + "static/media/videoIcon.3b20f8a0ed19a624e5fdcee75bc95b76.svg";
export { ForwardRef as ReactComponent };